/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'gatsby';

import { StyledDetails } from './DetailsStyles';
import { LazyImage } from '../../../../slices/atoms';

const Details = (authorObj, tagObj, blog_post_date, extraclass) => {
  const { author_image, author_name } = authorObj;
  const authorUid = authorObj._meta.uid;
  const RenderTag = () =>
    tagObj && tagObj.length >= 1
      ? tagObj.map((tag, index) => {
          const { tag1 } = tag;
          const tagName = tag1.tag;
          return (
            <Link to={`blog/tag/${tag1._meta.uid}`} className="tag" key={tagName}>
              {tagName}
              {tagObj.length > 1 && index < tagObj.length - 1 ? ',' : ' '}
            </Link>
          );
        })
      : null;

  return (
    <StyledDetails className={extraclass}>
      <div>
        {author_image && author_image.url ? (
          <LazyImage width="36px" src={author_image.url} alt={author_image.alt || 'author image'} />
        ) : null}
        {author_name ? <Link to={`/blog/author/${authorUid}`}>{author_name} </Link> : null}
        {tagObj && tagObj.length >= 1 ? 'on' : null}
        <RenderTag />
        <span>
          {blog_post_date ? '•' : ''}&nbsp; {blog_post_date}
        </span>
      </div>
    </StyledDetails>
  );
};
export default Details;
